import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import GoSetSendFeatureFlagsTrue from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-go-set-send-feature-flags-to-true.mdx";
import GoOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/go.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  GoSetSendFeatureFlagsTrue,
  GoOverrideServerProperties,
  React
};